<template>
    <div>
      <div class="popup-info popup-icon-info">
          <svg class="big-icon" style="width: 48px; height: 48px;">
            <use xlink:href="@/assets/img/big-icons-sprite.svg#info"></use>
          </svg>

          <div class="text mt24">
              <div class="text-size-ml text-bold info-title">Переместить договор?</div>

              <div class="move-rule --contract mt32">
              	<div class="prev cat">
                    {{ oldSectionName }}
              	</div>
				<svg class="arrow">
	              <use xlink:href="@/assets/img/big-icons-sprite.svg#arrow"></use>
	            </svg>
				<div class="next cat">
                    {{ newSectionName }}
				</div>
              </div>
          </div>

          <div class="mt32">
              <span class="btn btn--ico" @click="close">Подтвердить</span>
          </div>
      </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "MoveContract",
        props: {
            newSection: 0,
            oldSection: 0,
        },
        methods: {
            close: function () {
                this.$emit('move');
                this.$store.commit('popups/close', {name: this.popups.moveContract.name});
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                blockEdit: state => state.rules.blockEdit,
                sections: state => state.contracts.items,
            }),
            newSectionName(){
                return this.sections.find(item => item.id == this.newSection).name
            },
            oldSectionName(){
                return this.sections.find(item => item.id == this.oldSection).name
            }
        }
    }
</script>

<style scoped>

</style>
